import { normalizeKey } from '../../shared/verteoffice/exports/helpers/helpers'
import { generalToObjectiveType, objectiveToSpecificType } from './activityTypeMapping'
import { DOMAIN_CONFIG } from './domainConfig'

export interface ObjectiveOption {
  value: string
  label: string
  specificActivity: string
  generalActivity: string
}

export function buildAllObjectivesOptions(
  domainDataList: Record<string, string[]>
): ObjectiveOption[] {
  const canonicalGeneralByNormalized: Record<string, string> = {}
  for (const generalActivityName of domainDataList.generalActivityList ?? []) {
    canonicalGeneralByNormalized[normalizeKey(generalActivityName)] = generalActivityName
  }

  // Build specificActivity → generalActivity map at runtime from loaded domain data
  const specificToGeneral: Record<string, string> = {}
  const canonicalSpecificByNormalized: Record<string, string> = {}
  for (const [generalName, objectiveDomainType] of Object.entries(generalToObjectiveType)) {
    const configItem = DOMAIN_CONFIG.find(c => normalizeKey(c.type) === normalizeKey(objectiveDomainType))
    if (!configItem) continue
    const specificActivityNames = domainDataList[configItem.listKey] ?? []
    const canonicalGeneralActivity =
      canonicalGeneralByNormalized[normalizeKey(generalName)] ?? generalName
    for (const specificActivityName of specificActivityNames) {
      const normalizedSpecificActivity = normalizeKey(specificActivityName)
      specificToGeneral[normalizedSpecificActivity] = canonicalGeneralActivity
      canonicalSpecificByNormalized[normalizedSpecificActivity] = specificActivityName
    }
  }

  // Build flat list of all objectives grouped by specific_activity
  const raw: ObjectiveOption[] = []
  for (const [specificActivityName, specificType] of Object.entries(objectiveToSpecificType)) {
    const configItem = DOMAIN_CONFIG.find(c => normalizeKey(c.type) === normalizeKey(specificType))
    if (!configItem) continue
    const objectives = domainDataList[configItem.listKey] ?? []
    const canonicalSpecificActivity =
      canonicalSpecificByNormalized[normalizeKey(specificActivityName)] ?? specificActivityName
    const generalActivity = specificToGeneral[normalizeKey(canonicalSpecificActivity)] ?? ''
    for (const objectiveName of objectives) {
      raw.push({
        value: objectiveName,
        label: objectiveName,
        specificActivity: canonicalSpecificActivity,
        generalActivity
      })
    }
  }

  // Detect duplicate values and append parent context to label
  const counts: Record<string, number> = {}
  for (const opt of raw) {
    counts[opt.value] = (counts[opt.value] ?? 0) + 1
  }

  return raw.map(opt =>
    counts[opt.value] > 1
      ? { ...opt, label: `${opt.value} (${opt.specificActivity})` }
      : opt
  )
}
